const split = (key: string | RegExp) => (source: string) => source.split(key);

export default split;
